/**
 * Parse VMAP document to Json
 */
import xmlConvert from "xml-js";
import { AdType, CreativeType } from "../definitions/VAST3";
/**
 * main class for parse VMAP xml
 */
var VMAPParser = /** @class */ (function () {
    /**
     * @constructor
     * Set initial value
     * @param {string} xml
     */
    function VMAPParser(xml, debugMode) {
        if (debugMode === void 0) { debugMode = false; }
        this.debugMode = false;
        if (xml)
            this.xml = xml;
        this.debugMode = debugMode;
    }
    /**
     * Parse input xml string to IVMAP Object
     * @param {string} xml
     * @returns {IVMAP}
     */
    VMAPParser.prototype.JSON = function (xml) {
        if (!xml && !this.xml) {
            throw (new Error("XML input is required."));
        }
        var xmlString = xml || this.xml;
        var xmlObj = xmlConvert.xml2json(xmlString, {
            compact: true,
            spaces: 4
        });
        var VMAP = JSON.parse(xmlObj).VMAP;
        var breaks = Array.isArray(VMAP.AdBreak) ? VMAP.AdBreak : [VMAP.AdBreak];
        return {
            version: this.getVersion(VMAP),
            breaks: breaks.map(this.getBreaks.bind(this))
        };
    };
    /**
     * Parse version of VMAP
     * @param VMAP
     * @returns {string}
     */
    VMAPParser.prototype.getVersion = function (VMAP) {
        return VMAP._attributes ? VMAP._attributes.version : null;
    };
    /**
     * Parse ad breaks
     * @param AdBreak
     * @returns {IAdBreak}
     */
    VMAPParser.prototype.getBreaks = function (AdBreak) {
        return {
            breakTypes: [AdBreak._attributes ? AdBreak._attributes.breakType : null],
            breakId: AdBreak._attributes ? AdBreak._attributes.breakId : null,
            timeOffset: AdBreak._attributes ? AdBreak._attributes.timeOffset : null,
            adSource: {
                id: AdBreak.AdSource._attributes
                    ? AdBreak.AdSource._attributes.id
                    : null,
                VASTAdData: this.parseVASTAdDataAds(AdBreak.AdSource.VASTAdData.VAST),
                adDataType: AdBreak.AdSource.adDataType,
                adTagURI: AdBreak.AdSource.adTagURL,
                allowMultipleAds: AdBreak.AdSource.allowMultipleAds,
                dataType: AdBreak.AdSource._attributes
                    ? AdBreak.AdSource._attributes.dataType
                    : null,
                followRedirects: AdBreak.AdSource._attributes
                    ? AdBreak.AdSource._attributes.followRedirects
                    : null,
                customAdData: AdBreak.AdSource.customAdData
            },
            extensions: AdBreak.Extensions
                ? this.parseExtensions(AdBreak.Extensions.Extension)
                : [],
            repeatAfter: AdBreak._attributes.repeatAfter
        };
    };
    /**
     * Parse Vast ad Data
     * @param vast
     * @returns {IVAST3}
     */
    VMAPParser.prototype.parseVASTAdDataAds = function (vast) {
        return {
            version: vast._attributes ? vast._attributes.version : null,
            ads: this.parseAd(vast.Ad)
        };
    };
    /**
     * Parse ad
     * @param ad
     * @returns {Ad[]}
     */
    VMAPParser.prototype.parseAd = function (ad) {
        if (this.debugMode)
            console.debug("Parse ad", ad.InLine);
        // if (ad["InLine"]) {
        var liner = {
            id: ad._attributes.id,
            adSystem: {
                version: ad.InLine.AdSystem._attributes
                    ? ad.InLine.AdSystem._attributes.version
                    : null,
                name: ad.InLine.AdSystem._cdata
            },
            adTitle: ad.InLine.AdTitle._cdata,
            adType: AdType.inline,
            extensions: ad.InLine.Extensions.Extension
                ? this.parseExtensions(ad.InLine.Extensions.Extension)
                : [],
            creative: this.parseCreative(ad.InLine.Creatives.Creative),
            error: ad.InLine.Error ? ad.InLine.Error._text : null,
            sequence: ad.InLine.Sequence ? ad.InLine.Sequence._text : null,
            description: ad.InLine.Description._text,
            advertiser: ad.InLine.Advertiser ? ad.InLine.Advertiser._text : null,
            pricing: {
                value: ad.InLine.Pricing._text,
                currency: ad.InLine.Pricing._attributes
                    ? ad.InLine.Pricing._attributes.currency
                    : null,
                model: ad.InLine.Pricing._attributes
                    ? ad.InLine.Pricing._attributes.model
                    : null
            },
            survey: ad.InLine.Survey._text || ad.InLine.Survey._cdata,
            impressions: ad.InLine.Impression
                ? this.parseImpression(ad.InLine.Impression)
                : []
        };
        return [liner];
        // }
    };
    /**
     * Parse Creative
     * @param creativeInput
     * @returns {ICreative[]}
     */
    VMAPParser.prototype.parseCreative = function (creativeInput) {
        var _this = this;
        var creativeArray = creativeInput;
        if (!Array.isArray(creativeInput)) {
            creativeArray = [creativeInput];
        }
        var creativeOutputArray = [];
        creativeArray.forEach(function (creative) {
            var c = {
                id: creative._attributes ? creative._attributes.id : null,
                adID: creative._attributes ? creative._attributes.AdID : null,
                sequence: creative._attributes ? creative._attributes.sequence : null,
                skipoffset: creative.Linear._attributes.skipoffset,
                trackings: _this.parseTrackingEvents(creative.Linear.TrackingEvents.Tracking),
                videoClicks: _this.parseVideoClicks(creative.Linear.VideoClicks),
                extensions: creative.CreativeExtensions,
                mediaFiles: _this.parseMediaFile(creative.Linear.MediaFiles.MediaFile),
                duration: creative.Linear.Duration._text,
                creativeType: CreativeType.linear
            };
            creativeOutputArray.push(c);
        });
        return creativeOutputArray;
    };
    /**
     * Parse MediaFile
     * @param mediaFilesInput
     * @returns {IMediaFile[]}
     */
    VMAPParser.prototype.parseMediaFile = function (mediaFilesInput) {
        var mediaFilesArray = mediaFilesInput;
        if (!Array.isArray(mediaFilesInput)) {
            mediaFilesArray = [mediaFilesInput];
        }
        var mediaFilesOutputArray = [];
        mediaFilesArray.forEach(function (file) {
            var f = {
                id: file._attributes ? file._attributes.id : null,
                height: file._attributes ? file._attributes.height : null,
                width: file._attributes ? file._attributes.width : null,
                delivery: file._attributes ? file._attributes.delivery : null,
                codec: file._attributes ? file._attributes.codec : null,
                mimetype: file._attributes ? file._attributes.type : null,
                apiFramework: file._attributes ? file._attributes.apiFramework : null,
                bitrate: file._attributes ? file._attributes.bitrate : null,
                minBitrate: file._attributes ? file._attributes.minBitrate : null,
                maxBitrate: file._attributes ? file._attributes.maxBitrate : null,
                scalable: file._attributes ? file._attributes.scalable : null,
                maintainAspectRatio: file._attributes
                    ? file._attributes.maintainAspectRatio
                    : null,
                uri: file._cdata
            };
            mediaFilesOutputArray.push(f);
        });
        return mediaFilesOutputArray;
    };
    /**
     * Parse TrackingEvents
     * @param trackingInput
     * @returns {ITrackingEvent[]}
     */
    VMAPParser.prototype.parseTrackingEvents = function (trackingInput) {
        var trackingInputArray = trackingInput;
        if (!Array.isArray(trackingInput)) {
            trackingInputArray = [trackingInput];
        }
        var trackingOutputArray = [];
        trackingInputArray.forEach(function (tracking) {
            var f = {
                uri: tracking._cdata,
                event: tracking._attributes ? tracking._attributes.event : null
            };
            trackingOutputArray.push(f);
        });
        return trackingOutputArray;
    };
    /**
     * Parse VideoClicks
     * @param videoClickInput
     * @returns {IVideoClick}
     */
    VMAPParser.prototype.parseVideoClicks = function (videoClickInput) {
        var f = {
            clickTrackings: [],
            clickThrough: { uri: "", id: "" }
        };
        if (videoClickInput.ClickThrough) {
            f.clickThrough = {
                uri: videoClickInput.ClickThrough._cdata,
                id: videoClickInput.ClickThrough._attributes
                    ? videoClickInput.ClickThrough._attributes.id
                    : null
            };
        }
        if (videoClickInput.clickTrackings) {
            var clickTracking = videoClickInput.clickTrackings;
            if (!Array.isArray(videoClickInput.clickTrackings)) {
                clickTracking = [clickTracking];
            }
            f.clickTrackings = [];
            clickTracking.forEach(function (c) {
                if (f.clickTrackings) {
                    f.clickTrackings.push({
                        uri: c._cdata,
                        id: c._attributes ? c._attributes.id : null
                    });
                }
            });
        }
        if (videoClickInput.customClicks) {
            var customClicks = videoClickInput.customClicks;
            if (!Array.isArray(videoClickInput.customClicks)) {
                customClicks = [customClicks];
            }
            f.customClicks = [];
            customClicks.forEach(function (c) {
                if (f.customClicks) {
                    f.customClicks.push({
                        uri: c._cdata,
                        id: c._attributes ? c._attributes.id : null
                    });
                }
            });
        }
        return f;
    };
    /**
     * Parse Extensions
     * @param extensionsInput
     * @returns {IExtension[]}
     */
    VMAPParser.prototype.parseExtensions = function (extensionsInput) {
        var extensionsArray = extensionsInput;
        if (!Array.isArray(extensionsInput)) {
            extensionsArray = [extensionsInput];
        }
        var extensionsOutputArray = [];
        extensionsArray.forEach(function (extension) {
            var e = {
                value: extension._text,
                extensionType: extension._attributes ? extension._attributes.type : null
            };
            extensionsOutputArray.push(e);
        });
        return extensionsOutputArray;
    };
    /**
     * Parse Impressions
     * @param impressionInput
     * @returns {IAdImpression[]}
     */
    VMAPParser.prototype.parseImpression = function (impressionInput) {
        if (this.debugMode)
            console.debug("parse Impression", impressionInput._cdata);
        var impressionInputArray = impressionInput;
        if (!Array.isArray(impressionInput)) {
            impressionInputArray = [impressionInput];
        }
        var impressionOutput = [];
        impressionInputArray.forEach(function (impression) {
            impressionOutput.push({
                uri: impression._cdata
            });
        });
        return impressionOutput;
    };
    return VMAPParser;
}());
export { VMAPParser };
/**
 * export new Object of class
 */
export default new VMAPParser();
//# sourceMappingURL=index.js.map